import { notification } from "antd";
import axiosConfig from "../configs/axiosConfig";
// export const apiRegister = async (payload) => {
//   try {
//     if (payload.phoneNumber !== undefined) {
//       const response = await axiosConfig({
//         method: "POST",
//         url: "/v1/user-signup",
//         data: {
//           firstName: payload.firstName,
//           lastName: payload.lastName,
//           phoneNumber: payload.phoneNumber,
//           dateOfBirth: payload.dateOfBirth,
//           email: payload.email,
//           address: payload.address,
//           password: payload.password,
//           gender: payload.gender,
//           childUsers: payload.childUsers,
//           adultUsers: payload.adultUsers,
//         },
//       });

//       return response;
//     } else {
//       notification.error({
//         message: "Missing required field",
//         placement: "topRight",
//         duration: 2,
//       });
//     }
//   } catch (error) {
//     // notification.error({
//     //   message: "User ",
//     //   placement: "topRight",
//     //   duration: 2,
//     // });
//     // console.error(err.message);
//   }
// };
export const apiLogin = async (payload) => {
  try {
    const response = await axiosConfig({
      method: "POST",
      url: "/auth/signin.php",
      data: payload,
    });
    return response;
  } catch (error) {
    notification.error({
      message: "Email or password is incorrect",
      placement: "topRight",
      duration: 2,
    });
  }
};
